export interface ILocalisation {
    langues: Array<ILocalisationLibelle>;
}

export interface ILocalisationLibelle {
    id?: string;
    langueId?: string;
    libelle: string;
}

export abstract class Localisation<T extends ILocalisationLibelle> implements ILocalisation {

    langues: Array<T>;

    constructor(langues: Array<T>) {
        this.langues = langues;
    }

    getLangue(localeId: string): T {
        return this.langues.find(langue => langue.langueId === localeId);
    }

    getLibelle(localeId: string): string {
        const langueLibelle = this.getLangue(localeId);

        return langueLibelle ? langueLibelle.libelle : '';
    }
}
